import React from "react";
import PropTypes from 'prop-types';
import { HERO_MESSAGES } from '../messages.js';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const propTypes = {
  percentage: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

export default function HeroSection({percentage = 0, onClick}){
  let hero_keys;
  switch (true) {
    case (percentage < 25):
      hero_keys = 'bad';
      break;
    case (percentage < 60):
      hero_keys = 'almost';
      break;
    case (percentage < 80):
      hero_keys = 'good';
      break;
    default:
      hero_keys = 'excellent';
  }
  const messages = HERO_MESSAGES[hero_keys]

  return <Box id="result-hero" sx={{ backgroundColor: '#364753', color: '#FFF', textAlign: 'center', p: 4 }}>
    <Typography sx={{ fontSize: 34, fontWeight: 700, my: 2 }}>{messages.title}</Typography>
    <Typography sx={{ fontSize: 20, fontWeight: 600, my: 1 }}>{messages.subtitle}</Typography>
    {messages.lines.map((line, i) =><Typography key={i}>{line}</Typography> )}
    <Button
        id='btn-hero-header-cta'
        variant="contained"
        size="large"
        onClick={onClick}
        sx={{
          my: 4,
          px: 2,
          py: 1,
          backgroundColor: '#F6F7FC',
          color: '#223543',
          fontWeight: 600,
          fontSize: 15,
          '&:hover': {
            backgroundColor: '#22a3cb',
            color: '#FFFFFF',
          },
      }}
      >
        unlock full version for free
      </Button>
  </Box>;
}

HeroSection.propTypes = propTypes;